import {useState,useEffect} from 'react';
import { useTheme } from '../theming/default_theme';

const Greeting: React.FC = () => {
    const theme = useTheme();
    const [greeting, setGreeting] = useState('');
    const loggedinUser = localStorage.getItem('loggedinUser');
    const userName = loggedinUser ? JSON.parse(loggedinUser).firstName || 'Prashant' : 'Prashant';


    useEffect(()=>{
        const currentHour = new Date().getHours();
        if (currentHour < 12) {
            setGreeting('Good Morning');
        } else if (currentHour < 18) {
            setGreeting('Good Afternoon');
        } else {
            setGreeting('Good Evening');
        }
    }
    ,[])

    return (
        
        <div className="flex flex-row pl-[24px] block" style={{top:"48px",left:"264px",display:"block",fontFamily:theme.typography.fontFamily,fontWeight:theme.typography.fontWeightRegular,fontSize:theme.typography.h1.fontSize,color:theme.colors.text,}}>
                {greeting}, <span style={{ fontSize:theme.typography.h1.fontSize, fontWeight:theme.typography.fontWeightBold, paddingLeft:"5px" }}>{userName}</span><br />
                <span style={{ fontSize:theme.typography.fontSize, fontWeight:theme.typography.fontWeightRegular}}>Track, manage and see the latest updates here</span>
        </div>
        
    );
};

export default Greeting;